// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"9908eb7f","306":"20efe677"}[chunkId] + ".chunk.css";
};